




















































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

class productVariantOptions {
    product_option_id!:number;
    product_sku_id!:any;
    name!:string;
    file!:File;
    image_url!:string;
}
@Component({
    components: {
      ImageUpload,
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class ProductVariantOptions extends  Vue{
    items : productVariantOptions[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "productVariantOptions";
    action:string = this.baseAction;
    data : productVariantOptions = new productVariantOptions();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "product_option_id"
        },
        {text: "Başlık", value: "name"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:productVariantOptions){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.product_option_id;
        this.dialog = true;
    }
    add(){

        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new productVariantOptions();
        this.data.product_sku_id = this.$route.params.product_sku_id;
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction + "/" + this.$route.params.product_sku_id);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
